// TSS vite/04 §"Endpoint paths".
// URL knowledge lives here: a backend rename touches one file.
// No leading slash — axios joins baseURL + url with a single slash.

export const userPaths = {
    list:   ()   => 'admin/users',
    detail: (id) => `admin/users/${id}`,
    // A route of its own because changing a role is not editing a user: it
    // demands `users:admin` while the rest of the record only needs
    // `users:write`.
    role:   (id) => `admin/users/${id}/role`,
    // A QUÉ EQUIPOS PERTENECE, publicada por el backend (AD01).
    //
    // The panel used to answer this by inverting the teams side: one request
    // for the teams, one per team for its members, and the result turned inside
    // out. That worked and was never right — it only saw the first page of
    // teams, so the list could be quietly incomplete. This reads the membership
    // rows directly.
    //
    // It demands `users:read` AND `teams:read`: the first is declared on the
    // route, the second is applied in its middleware chain. Holding one of them
    // is not enough.
    teams:  (id) => `admin/users/${id}/teams`,
};
